import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from './common/Loading';
import LoggedOut from './common/LoggedOut';
import Dimmer from './common/Dimmer';
import Forbidden from './common/Forbidden';
/**
 * Component for managing the main body content of the Hyrule app. Depending on the auth status, it can display a mix of
 * dimmer, logged out and loading.
 *
 * @param authState - The auth state provided by useHyruleAuth hook
 * @param loadingCustom - Custom loading component
 * @param loggedOutCustom - Custom logged out component
 * @param routes - Route components setup by useHyruleNav hook
 */
const HyruleBody = _ref => {
  let {
    authState,
    loadingCustom,
    loggedOutCustom,
    routes
  } = _ref;
  let dimmer;
  let body;
  const loadingComponent = loadingCustom || /*#__PURE__*/React.createElement(Loading, null);
  const loggedOutComponent = loggedOutCustom || /*#__PURE__*/React.createElement(LoggedOut, null);
  if (authState.authenticating) {
    dimmer = /*#__PURE__*/React.createElement(Dimmer, null);
    body = loadingComponent;
  } else if (!authState.authenticated) {
    body = loggedOutComponent;
  } else {
    body = /*#__PURE__*/React.createElement("div", {
      "data-testid": "hyruleAppContent",
      id: "content"
    }, /*#__PURE__*/React.createElement(Switch, null, routes, /*#__PURE__*/React.createElement(Route, {
      path: "/logged-out",
      component: () => loggedOutComponent
    }), /*#__PURE__*/React.createElement(Route, {
      component: Forbidden
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, dimmer, body);
};
export default HyruleBody;